import z from "zod";

import { OVERLAP_MODES } from "./constants";

const timeSchema = z.string().regex(/^\d{1,2}:\d{2}$/u);

export const timeRangeSchema = z.object({
  begin: timeSchema,
  end: timeSchema,
});

const flag = (fallback: boolean) =>
  z
    .string()
    .optional()
    .transform((value) => (value === undefined ? fallback : value !== "false"));

export const timeRangePickerDataSchema = z.object({
  label: z.string().optional(),
  value: z
    .string()
    .optional()
    .transform((raw): unknown => (raw ? JSON.parse(raw) : []))
    .pipe(z.array(timeRangeSchema)),
  min: timeSchema.optional(),
  max: timeSchema.optional(),
  step: z.coerce.number().optional(),
  minDuration: z.coerce.number().optional(),
  majorTick: z.coerce.number().optional(),
  minorTick: z.coerce.number().optional(),
  overlap: z.enum(OVERLAP_MODES).optional(),
  overview: flag(false),
  disabled: flag(false),
  readonly: flag(false),
});

export type TimeRangePickerDataProps = z.infer<
  typeof timeRangePickerDataSchema
>;
